import Keycloak from 'keycloak-js'
import { serviceConfig } from '@/keycloack/config'
import { Service } from '@/keycloack/service'

let s = null

export function createKeycloakInstance() {
  const keycloakJsConfig1 = {
    url: process.env.VUE_APP_KEYCLOAK_JS_URL ?? '',
    realm: process.env.VUE_APP_KEYCLOAK_JS_REALM ?? '',
    clientId: process.env.VUE_APP_KEYCLOAK_JS_CLIENT_ID ?? ''
  }
  return new Keycloak(keycloakJsConfig1)
}

export function serviceFactory(userStore) {
  if(s === null) {
    s = new Service(createKeycloakInstance(), userStore, serviceConfig)
  }
  return s
}
